import { Link } from 'react-router-dom';
import '../../styles/components/pages/error-page.css';

export default function PermissionErrorPage() {
  return (
    <div className="error-container">
      <h1 className="error-heading">Oops!</h1>
      <p className="error-message">Sorry, you do not have permission to view this page.</p>
      <Link to="/" className="error-link">Return to Homepage</Link>
    </div>
  );
}